import React, { memo } from 'react';
import CrossFade from 'components/Transitions/CrossFade';
import VerticalBanner from 'components/Banners/Vertical';

interface BannerProps {
  background: string;
  backgroundType: string;
  foreground: string;
  name: string;
  ref: string;
  termsAndConditions: string;
}

interface SignupVerticalBannerProps {
  banners: Array<BannerProps>;
  step: number;
}

const SignupVerticalBanner = ({ banners, step }: SignupVerticalBannerProps) =>
  banners ? (
    <div className="signupVerticalBanner">
      {/* @ts-expect-error - TODO: Refactor Transitions component to typescript  */}
      <CrossFade childKey={step}>
        <VerticalBanner
          bannerName="registration"
          bannerStep={step}
          className="signupVerticalBanner__banner"
        />
      </CrossFade>
      {banners[step].termsAndConditions ? (
        <p className="signupVerticalBanner__footnote">{banners[step].termsAndConditions}</p>
      ) : null}
    </div>
  ) : null;

export default memo(SignupVerticalBanner);
